//#region ../icons/dist/html/scaffold/chevron.js
const chevronIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" fill=\"none\" aria-hidden=\"true\" viewBox=\"0 0 18 18\"><path stroke=\"currentColor\" d=\"M7.5 4.5 12 9l-4.5 4.5\"/></svg>";
//#endregion
export { chevronIcon };
